import { LoadingSpinner } from './loading-spinner.tsx';

export function LoadingBlockFullScreen() {
    return (
        <div className="flex h-dvh w-screen items-center justify-center">
            <LoadingSpinner />
        </div>
    );
}
